import { getArticleId } from '@utils/article';

/*
  ARTICLE DETAIL FEATURE MODULES | samostatné funkční celky

  To stejné co features.ts, ale pro detail článku (kvůli granularitě kódu).
*/

// LISTOVAČKA | Ovládání UI pro listovací články
export const articleListed = async () => {
  const wrapper: HTMLDivElement | null = document.querySelector('[data-article-listed]');

  if (wrapper) {
    const ArticleListed = await import(
      /* webpackChunkName: 'default/chunk-article-listed' */
      '@box/article/ArticleListed/ArticleListed'
    );

    ArticleListed.default();
  }
};

// Zámek článku
export const articleSubscription = async () => {
  const wrapper: HTMLDivElement | null = document.querySelector('[data-subscription]');

  if (wrapper) {
    const ArticleSubscription = await import(
      /* webpackChunkName: 'default/chunk-subscription' */
      '@box/article/ArticleSubscription'
    );

    ArticleSubscription.default();
  }
};

// ContentPay SMS odemčení samostatného článku
export const contentPaySmsUnlock = async () => {
  const smsUnlockForm: HTMLFormElement | null = document.querySelector(
    '[data-contentpay-sms-unlock]'
  );
  const addEmailForm: HTMLFormElement | null = document.querySelector('[data-contentpay-add-email]');

  if (smsUnlockForm || addEmailForm) {
    const { contentPaySmsUnlock } = await import(
      /* webpackChunkName: 'default/chunk-contentpay-sms-unlock' */
      '@box/article/contentPaySmsUnlock'
    );

    await contentPaySmsUnlock();
  }
};

// GALERIE | Simple slider
export const smallGallery = async () => {
  const galleryElement: HTMLDivElement | null = document.querySelector('[data-small-gallery]');

  if (galleryElement) {
    const { default: SmallGallery } = await import(
      /* webpackChunkName: 'default/chunk-small-gallery' */
      '@features/gallery/SmallGallery'
    );

    SmallGallery(galleryElement);
  }
};

// Zobrazení a skrytí photo credit popisku
export const photoCreditToggle = async () => {
  const iconSelectors = [...document.querySelectorAll('[data-i-icon-photo-credit]')];

  if (iconSelectors.length > 0) {
    const PhotoCreditToggle = await import(
      /* webpackChunkName: 'default/chunk-photo-credit-toogle' */
      '@box/article/PhotoCreditToggle'
    );

    iconSelectors.forEach((iconSelector) => {
      if (iconSelector instanceof HTMLDivElement) {
        PhotoCreditToggle.default(iconSelector);
      }
    });
  }
};

// Kliknutí na ikonu + otevření nového okna
export const socialClick = async () => {
  const socialShareElements: NodeListOf<HTMLElement> = document.querySelectorAll(
    '[data-social-action="share"]'
  );

  if (socialShareElements && socialShareElements.length) {
    const { socialClick: init } = await import(
      /* webpackChunkName: 'default/chunk-social-click' */
      '@features/socialClick'
    );
    init(socialShareElements);
  }
};

// Obalení tabulky pro scrollovaní FEG-722
export const scrollForTable = async () => {
  const dataBrandDiv: HTMLDivElement | null = document.querySelector('#dataBrand');
  if (!dataBrandDiv) return;
  const tables = dataBrandDiv.querySelectorAll('table');

  if (tables && tables.length) {
    const { scrollableTables } = await import(
      /* webpackChunkName: 'default/chunk-table' */
      '@utils/table'
    );

    scrollableTables(tables);
  }
};

//ulozit a restorovat scroll pozici pri otevreni galerie z imgInArt / gallery stripu
export const galleryInArtScrollPreserver = async () => {
  const articleId = getArticleId();
  if (!articleId) return;

  const a = document.querySelectorAll('.article-image .img-in-art-gallery-link, .article-gallery-strip__item a');
  if (!a || !a.length) return;

  const { galleryInArtPreserveScroll } = await import(
    /* webpackChunkName: 'default/gallery-in-art-preserve-scroll' */
    '@artobj/ImageInArt'
  );
  galleryInArtPreserveScroll(a, articleId);
};

// Online report – refresh nových příspěvků + discussion toggle + budoucí funkce
export const onlineReport = async () => {
  const onlineReports: NodeListOf<HTMLElement> =
    document.querySelectorAll('[data-online-report-id]');

  if (onlineReports.length) {
    const { initOnlineReport } = await import(
      /* webpackChunkName: 'default/chunk-online-report' */
      '@box/onlineReport/OnlineReport'
    );

    initOnlineReport(onlineReports);
  }
};
